import * as braintree from 'braintree-web'

import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

// return mock telephone number to enable local testing -
// sandbox currently returns a generic invalid US number ("035-369-1016")
export const savePayPalExpressCheckoutPersonalInfo: CheckoutActionCreator = ({
  firstName,
  lastName,
}: // phone,
braintree.PayPalTokenizePayload['details']) => ({
  type: actionTypes.SAVE_PAYPAL_EXPRESS_CHECKOUT_PERSONAL_INFO,
  personalInfo: {
    firstName,
    lastName,
    phoneNumber: '02031234567',
  },
})
